module.exports = __webpack_public_path__ + "static/media/admin-icon.2ae955e7.svg";